import createIcon from "./createIcon";

export const VipLogoDrakenIcon = createIcon('VipLogoDraken', (props) => {
  return (
    <svg {...props} viewBox="0 0 20 20" fill="none">
      <defs>
        {/* Safari 不支持 effect 标签，改用标准滤镜 */}
        <filter id="filter_15" width="16.7519531" height="11.3182678" x="1.15625" y="8.34275818" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          {/* 原始效果近似实现 */}
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend result="shape" in="SourceGraphic" in2="BackgroundImageFix" mode="normal" />
          <feColorMatrix result="hardAlpha" in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0 " />
          <feOffset dx="-0.163398698" dy="0.163398698" />
          <feGaussianBlur stdDeviation="0.108932465" />
          <feComposite k2="-1" k3="1" in2="hardAlpha" operator="arithmetic" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.505882 0 " />
          <feBlend result="effect_innerShadow_1" in2="shape" mode="normal" />
        </filter>

        {/* Safari 需要驼峰命名法 */}
        <linearGradient id="paint_linear_17" x1="9.53108788" x2="9.53108788" y1="19.3277054" y2="5.53651524" gradientUnits="userSpaceOnUse">
          <stop stopColor="rgb(236.786,219.257,191.581)" offset="0" stopOpacity="1" />
          <stop stopColor="rgb(212.879,189.829,156.757)" offset="0.402354449" stopOpacity="1" />
          <stop stopColor="rgb(202,180,145)" offset="0.664765596" stopOpacity="1" />
          <stop stopColor="rgb(173,150,117)" offset="0.874483347" stopOpacity="1" />
        </linearGradient>

        {/* Safari 不支持 effect 标签，改用标准滤镜 */}
        <filter id="filter_16" width="20.328125" height="11.1865845" x="-0.5546875" y="0.239990234" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          {/* 原始效果近似实现 */}
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend result="shape" in="SourceGraphic" in2="BackgroundImageFix" mode="normal" />
          <feColorMatrix result="hardAlpha" in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0 " />
          <feOffset dx="0.222222239" dy="0.555555582" />
          <feComposite k2="-1" k3="1" in2="hardAlpha" operator="arithmetic" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.843137 0 0 0 0 0.792157 0 0 0 0 0.733333 0 0 0 1 0 " />
          <feBlend result="effect_innerShadow_1" in2="shape" mode="normal" />
        </filter>

        {/* Safari 需要驼峰命名法 */}
        <linearGradient id="paint_linear_18" x1="7.78717804" x2="7.25625229" y1="15.6365337" y2="-5.68087196" gradientUnits="userSpaceOnUse">
          <stop stopColor="rgb(191,159,119)" offset="0.0469924957" stopOpacity="1" />
          <stop stopColor="rgb(114,85,59)" offset="0.427456886" stopOpacity="1" />
          <stop stopColor="rgb(179,147,108)" offset="0.690445721" stopOpacity="1" />
          <stop stopColor="rgb(114,85,59)" offset="0.987223804" stopOpacity="1" />
        </linearGradient>
      </defs>

      {/* 保留原始结构，仅修改不兼容属性 */}
      <rect id="会员logo4" width="20" height="20" x="0" y="0" fill="rgb(255,255,255)" fillOpacity="0" />

      <g id="组合 161">
        <g filter="url(#filter_15)">
          <path
            id="减去顶层1"
            d="M11.5631 19.3274L16.1188 19.2645C17.412 19.2467 18.0541 17.6884 17.1488 16.7648L9.97252 9.44201C9.47397 8.93329 8.78552 8.65605 8.07355 8.67728L2.67502 8.83831C1.61066 8.87006 1.09582 10.1554 1.84397 10.9132L9.19254 18.3558C9.81754 18.9888 10.6736 19.3396 11.5631 19.3274Z"
            fill="url(#paint_linear_17)"
            fillRule="evenodd"
          />
          <path
            id="减去顶层2"
            d="M10.8462 19.5986Q11.2001 19.6658 11.5677 19.6607L16.1234 19.5978Q16.4605 19.5932 16.7555 19.4794Q16.9613 19.4 17.1465 19.2674Q17.3312 19.1354 17.4733 18.9674Q17.6543 18.7535 17.7664 18.4813Q17.8786 18.2092 17.9008 17.9298Q17.9183 17.7105 17.8803 17.4867Q17.8421 17.2621 17.752 17.0608Q17.6229 16.7722 17.3869 16.5315L10.2106 9.2087Q9.9992 8.993 9.75343 8.82875Q9.50769 8.66451 9.22758 8.55171Q8.94745 8.4389 8.65646 8.387Q8.36547 8.33509 8.06361 8.3441L2.66508 8.50513Q2.37906 8.51366 2.12944 8.61335Q1.95236 8.68408 1.7936 8.80069Q1.63592 8.91651 1.51529 9.06287Q1.3635 9.24704 1.27037 9.47955Q1.17724 9.71207 1.15992 9.9501Q1.14617 10.1393 1.18029 10.3319Q1.21466 10.5259 1.29395 10.6993Q1.40572 10.9437 1.60677 11.1474L8.95534 18.59Q9.21363 18.8516 9.51286 19.0521Q9.81207 19.2526 10.1522 19.392Q10.4924 19.5314 10.8462 19.5986ZM16.1188 19.2645L11.5631 19.3274C10.6736 19.3396 9.81754 18.9888 9.19254 18.3558L1.84397 10.9132C1.09582 10.1554 1.61066 8.87006 2.67502 8.83831L8.07355 8.67728C8.78552 8.65605 9.47397 8.93329 9.97252 9.44201L17.1488 16.7648C18.0541 17.6884 17.412 19.2467 16.1188 19.2645Z"
            fill="rgb(138.884,120.366,108.582)"
            fillRule="evenodd"
          />
        </g>

        <g filter="url(#filter_16)">
          <path
            id="路径 2431"
            d="M2.65836 11.0931L8.26948 11.031C9.30527 11.0195 10.293 10.5922 11.0105 9.84503L17.8383 2.73506C18.5755 1.96739 18.0438 0.689854 16.9796 0.671969L11.132 0.573691C10.4418 0.56209 9.77623 0.830618 9.28729 1.31801L1.72103 8.86024C0.890571 9.68807 1.48585 11.1061 2.65836 11.0931Z"
            fill="url(#paint_linear_18)"
            fillRule="evenodd"
          />
          <path
            id="路径 2432"
            d="M2.66205 11.4265L8.27317 11.3643Q8.69514 11.3596 9.09976 11.2735Q9.5044 11.1874 9.89171 11.0198Q10.279 10.8523 10.6187 10.6163Q10.9586 10.3803 11.2509 10.0759L18.0787 2.96595Q18.2768 2.75968 18.3852 2.51386Q18.4621 2.3394 18.4938 2.14502Q18.5253 1.95198 18.5089 1.76306Q18.4884 1.52539 18.3922 1.29425Q18.296 1.06314 18.1418 0.881097Q18.0193 0.736379 17.8601 0.622677Q17.6999 0.50821 17.5219 0.439839Q17.2711 0.343489 16.9852 0.338683L11.1376 0.240405Q10.845 0.235486 10.5629 0.287792Q10.2809 0.340093 10.0094 0.449608Q9.73803 0.559119 9.49868 0.717183Q9.25928 0.875273 9.05196 1.08193L1.4857 8.62417Q1.26441 8.84476 1.14348 9.11094Q1.05924 9.29638 1.0237 9.50395Q0.988406 9.7101 1.00485 9.91204Q1.02584 10.17 1.13123 10.421Q1.23662 10.6721 1.40603 10.8677Q1.53865 11.0209 1.71051 11.1401Q1.88355 11.2601 2.07491 11.3298Q2.34961 11.4299 2.66205 11.4265ZM8.26948 11.031L2.65836 11.0931C1.48585 11.1061 0.890571 9.68807 1.72103 8.86024L9.28729 1.31801C9.77623 0.830618 10.4418 0.56209 11.132 0.573691L16.9796 0.671969C18.0438 0.689854 18.5755 1.96739 17.8383 2.73506L11.0105 9.84503C10.293 10.5922 9.30527 11.0195 8.26948 11.031Z"
            fill="rgb(94.4866,73.1284,60.1278)"
            fillRule="evenodd"
          />
        </g>
      </g>
    </svg>
  );
});